import React, { useEffect, useState } from 'react';
import './index.css';
import ImageTag from '../ImageTag/Index';

const PopupCreative = 'https://triverseadvertising.com/iec_website_clone/images/iec-satish-goyal.jpeg';

const Index = ({ image = PopupCreative, imageAlt = 'In Loving Memory of Satish Goel', link }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('popupImage-open', isOpen);
    return () => document.body.classList.remove('popupImage-open');
  }, [isOpen]);

  if (!isOpen) return null;

  const handleClose = () => setIsOpen(false);

  const creative = (
    <ImageTag
      ImagePath={image}
      ImageAlt={imageAlt}
      ImageClass={`popupImage-img${imageLoaded ? ' popupImage-img--loaded' : ''}`}
      onLoad={() => setImageLoaded(true)}
    />
  );

  return (
    <div className="popupImage-overlay position-fixed flex-center">
      <div className="popupImage-box position-relative" role="dialog" aria-modal="true" aria-label={imageAlt}>
        <button
          type="button"
          className="popupImage-close"
          aria-label="Close popup and enter website"
          onClick={handleClose}
        />
        {link ? (
          <a href={link} target="_blank" rel="noreferrer">
            {creative}
          </a>
        ) : (
          creative
        )}
      </div>
    </div>
  );
};

export default Index;
